export enum PreLoaderColor {
  White = "white",
  Grey = "grey",
  DarkGrey = "darkGrey",
  Primary = "primary",
  PrimaryLight = "primaryLight",
  Secondary = "secondary",
}
